module.exports = __webpack_public_path__ + "img/question.265c571c.png";